/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInAccountMiniAccountType = typeof LinkedInAccountMiniAccountType[keyof typeof LinkedInAccountMiniAccountType];


export const LinkedInAccountMiniAccountType = {
  free: 'free',
  premium: 'premium',
  recruiter: 'recruiter',
  sales_navigator: 'sales_navigator',
} as const;
